import store from '@/store'
import { Action, config, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import Vue from "vue";
import Scoring from "@/store/modules/Scoring";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import Decisions from "@/store/modules/Decisions";
//@ts-ignore
import { Choice } from '@/api/model/Choice';
import Modelling from "@/store/modules/Modelling";
import _ from "lodash";
import WorkspaceOptions from './WorkspaceOptions';
import { ChoiceList, ChoiceListItem, ResourceList } from '@/api/model/ResourceList';
import Users from './Users';
import { NotificationEventBus } from "@/EventBus";

// import WorkspaceOptions from './WorkspaceOptions';

config.rawError = true

const name = 'choices';
if (module.hot) {
    if (store.hasModule(name)) {
        store.unregisterModule(name);
    }
}

// const workspaceModule = getModule(WorkspaceOptions);

@Module({dynamic: true, store: store, name: name, namespaced: true})
export default class Choices extends VuexModule {

    choices: any = {};

    selectedChoiceId: string | null = null;

    unfilteredChoices: any = {};

    lastChoiceMapping: any = {};

    get selectedChoice(): any {
        if (this.selectedChoiceId && this.choices) {
            return this.choices[this.selectedChoiceId];
        }
        return null;
    }

    get selectedChoiceName(): string {
        return this.selectedChoice ? this.selectedChoice.name : '';
    }
  
    get choiceIds() {
        return Object.keys(this.choices);
    }

    get unfilteredChoiceIds() {
        return Object.keys(this.unfilteredChoices);
    }

    get choicesList() {
        let res: any[] = Object.values(this.choices).sort((a: any, b: any) => {
            if (a.name === null || a.name === undefined) a.name = '';
            if (b.name === null || b.name === undefined) b.name = '';
            return a.name.localeCompare(b.name);
        });
        return res;
    }

    get unfilteredChoicesList() {
        let res: any[] = Object.values(this.unfilteredChoices).sort((a: any, b: any) => {
            if (a.name === null || a.name === undefined) a.name = '';
            if (b.name === null || b.name === undefined) b.name = '';
            return a.name.localeCompare(b.name);
        });
        return res;
    }

    @Mutation
    clear() {
        this.choices = {};
        this.unfilteredChoices = {};
        this.selectedChoiceId = null;
        this.lastChoiceMapping = {};
    }


    @Mutation
    setChoices(choices: any) {
        this.choices = Object.assign({}, choices);
    }

    @Mutation
    setUnfilteredChoices(choices: any) {
        this.unfilteredChoices = Object.assign({}, choices);
    }

    @Mutation
    setChoice(choice: Choice) {
        if (!choice.id) return;
        Vue.set(this.choices, choice.id, choice);
    }

    @Mutation
    removeSelectedChoice() {
        if (this.selectedChoiceId) {
            Vue.delete(this.choices, this.selectedChoiceId);
            Vue.delete(this.unfilteredChoices, this.selectedChoiceId);
            // delete choices from list manager
            getModule(Decisions).deleteChoiceFromList();
            this.selectedChoiceId = null;
        }
    }

    @Mutation
    removeChoice(choiceId: string) {
        Vue.delete(this.choices, choiceId);
        Vue.delete(this.unfilteredChoices, choiceId);
        // delete choices from list manager
        getModule(Decisions).deleteChoiceFromList();
    }

    @Mutation
    setSelectedChoiceId(choiceId: string | null) {
        this.selectedChoiceId = choiceId;
    }

    @Mutation
    setfilteredChoices(activeChoiceLists: string[]) {
        let allLists = getModule(Decisions).decisionLists
        let filteredChoices: string[] = [];
        let choiceLists = allLists as { [listId: string]: ChoiceList };
        if (choiceLists && activeChoiceLists && activeChoiceLists.length) {
            for (let id of Object.values(activeChoiceLists)) {
                if (choiceLists[id]) {
                    filteredChoices = filteredChoices.concat(choiceLists[id].choices.map((id: ChoiceListItem) => id.choiceId as string))
                } else {
                    continue;
                }

            }
        
            filteredChoices = _.uniq(filteredChoices);
            this.choices = _.pick(this.unfilteredChoices, filteredChoices)
        }
    }

    @Mutation
    setChoiceMapping(map: any) {
        this.lastChoiceMapping = _.cloneDeep(map);
    }


    @Action
    selectChoice(choiceId: string | null) {
        this.setSelectedChoiceId(choiceId);
    }

    @Action
    async fetchChoices() {
        let decision = getModule(Decisions).selectedDecision;
        let decisionsModule = getModule(Decisions)
        const decisionUsers = decisionsModule.selectedDecisionUsers;
        if (!decision && decisionUsers != null) return;
        let usersModule = getModule(Users)
        let choices = (await VIEWPOINT_API.getChoices(decision.choicesSourceId)).choices;
        if (choices.length > 0) {
            choices = choices.filter((choice) => {
                switch (choice.visibility) {
                    case "PRIVATE":
                        if ([choice.ownerUserId, decisionsModule.selectedDecision.ownerUserId].includes(usersModule.currentUserProfile.userId) && usersModule?.currentUserProfile?.userId != null || decisionsModule.isAdmin) {
                            return true
                        } else return false
                    case "PUBLIC":
                        return true;
                    default: return true;
                }
            })
        }
        

        this.setUnfilteredChoices(_.keyBy(choices, 'id'));

    //    if(workspaceModule.filteredChoiceIds.length > 0 && Object.keys(choices).length) {
    //        let lists = getModule(Decisions).decisionLists;
    //        choices = choices.filter((choice: Choice) => workspaceModule.filteredChoiceIds.includes(choice.id))
    //    }
        
        this.setChoices(_.keyBy(choices, 'id'));

    }

    @Action
    async createChoices(payload: Choice[]) {
        let decision = getModule(Decisions).selectedDecision;
        if (!decision) return;

        let formattedChoices = [];
        for (let rawChoice of payload) {
            let choice = Choices.cleanseChoiceData(rawChoice);
            choice.shareSetting ??= "VIEW"
            formattedChoices.push(choice);
        }

        let newChoicesMap = await VIEWPOINT_API.createChoices(decision.choicesSourceId, formattedChoices) as { [id: string]: Choice };
        Object.values(newChoicesMap).forEach((newChoice: Choice) => this.setChoice(newChoice));

        getModule(Scoring).refreshScoring();
        return newChoicesMap;
    }

    @Action
    async createChoice(payload: Choice) {
        let choice = Choices.cleanseChoiceData(payload);
        choice.shareSetting ??= "VIEW";
        let decision = getModule(Decisions).selectedDecision;
        if (!decision) return;
        let newChoice = await VIEWPOINT_API.createChoice(decision.choicesSourceId, choice);
        this.setChoice(newChoice);
        // kathy - update unfilteredChoices after creating a new choice
        this.setUnfilteredChoices(_.keyBy(this.choices, 'id'));
        // kathy - reset column width for all the choices
        getModule(WorkspaceOptions).resetChoiceColumnsWidth();
        getModule(Scoring).refreshScoring();
        return newChoice;
    }

    @Action
    async updateChoiceImage(payload: { choiceId: string, image: string }) {
        let choice = this.choices[payload.choiceId];
        let cleansedChoice = Choices.cleanseChoiceData(choice);
        let selectedDecision = getModule(Decisions).selectedDecision
        if (!selectedDecision) return;

        return await VIEWPOINT_API.updateChoice(selectedDecision.choicesSourceId, payload.choiceId, cleansedChoice);
    }

    @Action
    async updateChoiceField(payload: { choiceId: string, value: any, factorResourceId: string, refreshScoring: boolean }) {
        let modelModule = getModule(Modelling);
        let factorResource = modelModule.publishedModelFactorResources[payload.factorResourceId]
        if (!factorResource || !factorResource.dataField) return;
        this.choices[payload.choiceId][factorResource.dataField] = payload.value;
        let updatedChoice = await this.updateChoice({
            choice: this.choices[payload.choiceId],
            refreshScoring: payload.refreshScoring
        })
        // if (!payload.refreshScoring && factorResource.type === 'FACTOR') {
        //     if ('NUMERICAL' === viewpointsModule.selectedDraftFactors[payload.factorResourceId].valueType) {
        //         let nonManualScoringDefinitionCount = Object.values(viewpointsModule.viewpointFactors)
        //             .map((vf: any) => vf[payload.factorResourceId])
        //             .filter(f => f && f.scoringDefinition)
        //             .map(f => f.scoringDefinition.type)
        //             .filter(t => t && t !== 'MANUAL')
        //             .length
        //         if (nonManualScoringDefinitionCount > 0) {
        //             await  getModule(Scoring).invalidateScoring();
        //         }
        //     } else if (viewpointsModule.selectedDraftFactors[payload.factorResourceId].valueType === 'CATEGORICAL') {
        //         await  getModule(Scoring).invalidateScoring();
        //     }
        // }
        return updatedChoice;
    }

    @Action
    async updateChoice(payload: { choice: Choice, refreshScoring: boolean }) {
        let choice = Choices.cleanseChoiceData(payload.choice)
        let selectedDecision = getModule(Decisions).selectedDecision
        if (!choice.id || !selectedDecision) return;

        let updatedChoice = await VIEWPOINT_API.updateChoice(selectedDecision.choicesSourceId, choice.id, choice)
        this.setChoice(updatedChoice);

        if (payload.refreshScoring) {
            getModule(Scoring).refreshScoring();
        }
        await getModule(WorkspaceOptions).resetChoiceColumnsWidth();
        getModule(Scoring).refreshScoring();
        return updatedChoice;
    }

    @Action
    async renameChoice(payload: {newName: string, choice: Choice}) {
        let cloneChoice = _.cloneDeep(payload.choice);
        cloneChoice.name = payload.newName;
        await this.updateChoice({choice: cloneChoice, refreshScoring: true})
    }

    @Action
    async deleteChoice(choiceId: string) {
        let selectedDecision = getModule(Decisions).selectedDecision
        if (!choiceId || !selectedDecision) return;
        await VIEWPOINT_API.deleteChoice(selectedDecision.choicesSourceId, choiceId)
        await this.removeChoice(choiceId);
        if(this.choicesList.length > 0) {
            this.selectChoice(this.choicesList[0].id)
        }
    }

    @Action
    async deleteMultiple(choices: any) {
        for(let choice of choices) {
            await this.deleteChoice(choice.id)
        }
        await this.fetchChoices()
    }

    static cleanseChoiceData(choice: Choice): Choice {
        for (let key in choice) {
            if (choice.hasOwnProperty(key)) {
                let val = choice[key];
                if (val === null || val === '') {
                    delete choice[key]
                }
            }
        }
        return choice
    }

    @Action
    async convertFile(payload: {data: any, fileName: string}) {
        console.log(payload.fileName)
        let url = await VIEWPOINT_API.convertFile(payload.data, payload.fileName)
        return url
    }

    @Action
    async filterChoices(listIds: string[]) {
    // Use the ChoiceId's to filter fill choices 
        let workspaceModule = getModule(WorkspaceOptions)
        if (Object.keys(this.unfilteredChoices).length) {
            this.setfilteredChoices(listIds);
            //choices = choices.filter((choice: Choice) => workspaceModule.filteredChoiceIds.includes(choice.id))
            
            //If choice list is active and doesn't contain selected choice, default to first choice in list 
            if(workspaceModule.activeChoiceLists.length > 0 && !this.choicesList.includes(this.selectedChoiceId)) {
                this.selectChoice(this.choicesList[0]?.id)
            }
        }
    }

    @Action
    async copyChoice(payload: {choice: Choice, newChoiceParams: any}) {
        NotificationEventBus.emitProcessingMessage();
        try {
            let originalChoiceForm = _.cloneDeep(this.choices[payload.choice.id]);
            let newChoiceParams = payload.newChoiceParams;
            let newChoiceForm = Object.assign({}, originalChoiceForm);
            newChoiceForm.name = payload.newChoiceParams.name;
            delete newChoiceForm.id;
            let res = await VIEWPOINT_API.createChoice(newChoiceForm.choicesSourceId, newChoiceForm);

            if (newChoiceParams.addToList) {
                getModule(Decisions).addChoiceToActiveLists(res.id)
            }
            await this.fetchChoices();
            this.selectChoice(res.id);
            getModule(WorkspaceOptions).resetChoiceColumnsWidth();
            await getModule(Scoring).refreshScoring();
            NotificationEventBus.emitSuccessMessage();
        } catch (error) {
            NotificationEventBus.emitFailedMessage(error);
        }
    }

    @Action
    async copyMultipleChoices(payload: {choiceNameMapping: any, addToList?: boolean}) {
        let mapping = payload.choiceNameMapping;
        let newChoices: Choice[] = [];
        for(let choice of Object.keys(mapping)) {
            let cloneOldChoice = _.cloneDeep(this.choices[choice]);
            cloneOldChoice.name = mapping[choice] ? mapping[choice] : `Copy of ${cloneOldChoice.name}`;
            cloneOldChoice.id = null;
            newChoices.push(cloneOldChoice);
        }
        
        let result = await this.createChoices(newChoices);
        if(payload.addToList) {
            let decisionsModule = getModule(Decisions);
            Object.values(result).forEach((newChoice: Choice) => decisionsModule.addChoiceToActiveLists(newChoice.id));

        }

    }

    @Action
    async saveChoiceMapping(map: any) {
        this.setChoiceMapping(map) 
    }

    get checkChoiceVisibility() {
        let userModule = getModule(Users);
        let decisionsModule = getModule(Decisions);
        if(this.selectedChoice != null) {
            if(this.selectedChoice.visibility === 'PRIVATE') {
                //User is owner of choice or decision allow edits
                if ([this.selectedChoice.ownerUserId, decisionsModule.selectedDecision.ownerUserId].includes(userModule.currentUserProfile.userId)) {
                    return true
                } else if(decisionsModule.isAdmin) {
                    return true;
                } else {
                    return false
                }
            } else {
                return true;
            }          
        }
    }

    get checkChoiceEditPermissions() {
        let userModule = getModule(Users);
        let decisionsModule = getModule(Decisions);
        if (this.selectedChoice != null) {
            if(this.selectedChoice.ownerUserId === userModule?.currentUserProfile?.userId) {
                return true
            }
            //Owner of decision can always delete choices
            if (decisionsModule.selectedDecision.ownerUserId === userModule.currentUserProfile.userId) {
                return true
            }

            if(decisionsModule.isAdmin) {
                return true;
            }
           
            if(this.selectedChoice?.shareSetting === 'VIEW') {
               return false
            }
        }
        return true
    }
}

export {
    Choice,
}